import { BaseSerializedInfluxLineChart } from '@/composables/charts/influx-charts/chart-builders/ChartInterfaces'
import { AbstractInfluxLineChartBuilder } from '@/composables/charts/influx-charts/chart-builders/AbstractInfluxLineChartBuilder'
import { CHART_TYPES } from '@/composables/charts/influx-charts/chart-builders/CHART_TYPES'
import { CompiledInfluxQueryObject } from '@/composables/charts/influx-charts/query-builders/InfluxTypes'

export class InfluxLineChartBuilder extends AbstractInfluxLineChartBuilder {
  measurement: string
  field: string

  constructor(serialized: BaseSerializedInfluxLineChart) {
    super(serialized)
    this.measurement = serialized.measurement
    this.field = serialized.field
  }

  buildQuery(): CompiledInfluxQueryObject {
    return this.buildQueryForSingleQuery(this.measurement, this.field)
  }

  serialize(): BaseSerializedInfluxLineChart {
    return {
      ...super.serialize(),
      chartType: CHART_TYPES.LINE,
      measurement: this.measurement,
      field: this.field,
      xAggregation: this.xAggregation,
    }
  }

  autoInferChartEntity(serialized?: BaseSerializedInfluxLineChart): string | undefined {
    const localMeasurement = this.measurement ? this.measurement : serialized?.measurement
    if (!localMeasurement) return undefined
    return `frontend-charts.${localMeasurement}`
  }
}
